import {Button} from "antd";
import React from "react";

const logo = "https://vigo-software.s3.eu-west-1.amazonaws.com/mail-html-assets/vigo-logo-new.png";

const FallbackComponent = () => {
    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#f5f6fa",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                    padding: "40px 32px 32px 32px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    maxWidth: 400,
                    width: "100%"
                }}
            >
                <img
                    src={logo}
                    alt="Vigo Panel Logo"
                    style={{width: 180, height: 90, marginBottom: 24, objectFit: "contain"}}
                />
                <div
                    style={{
                        color: "#000",
                        fontWeight: 600,
                        fontSize: 20,
                        marginBottom: 8,
                        textAlign: "center"
                    }}
                >
                    Bir hata oluştu
                </div>
                <div
                    style={{
                        color: "#616161",
                        fontSize: 16,
                        marginBottom: 24,
                        textAlign: "center"
                    }}
                >
                    Sayfa yüklenirken bir hata oluştu. Lütfen sayfayı yenileyiniz.
                </div>
                <Button
                    style={{
                        background: "#AEF01F",
                        color: "#000",
                        border: "none",
                        borderRadius: 8,
                        padding: "16px 32px",
                        fontWeight: 600,
                        fontSize: 16,
                        cursor: "pointer",
                        transition: "background 0.2s"
                    }}
                    onClick={() => window.location.reload()}
                >
                    Sayfayı Yenile
                </Button>
            </div>
        </div>
    );
};

export default FallbackComponent;
